import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TicketToast from './Toasts/ticketToast';
import DefaultToast from './Toasts/defaultToast';
import LogsFeedbackToast from './Toasts/logsFeedbackToast';
import LogsFeedbackScheduled from './Toasts/logsFeedbackScheduledToast';

const ToastContainer = ({ toasts }) => {
  function getCustomElement(toast) {
    switch (toast.get('customElementType')) {
      case 'ticket-alert':
        return <TicketToast key={toast.get('id')} toastData={toast} />
      case 'logs-feedback': 
        return <LogsFeedbackToast key={toast.get('id')} toastData={toast} />
      case 'logs-feedback-scheduled': 
        return <LogsFeedbackScheduled key={toast.get('id')} toastData={toast} />
      default:
        return <DefaultToast key={toast.get('id')} toastData={toast} />;
    }
  }

  function renderToast(toast) {
    if (toast.has('customElementType')) {
      return getCustomElement(toast);
    }

    return <DefaultToast key={toast.get('id')} toastData={toast} />;
  }

  const toastContainerClassName = useMemo(
    () => `toast-notifications-container ${toasts.size > 0 ? 'has-toasts' : ''}`, 
    [toasts.size]
  );

  return (
    <div 
      data-testid={toastContainerClassName}
      className={toastContainerClassName}
    >
      {toasts.map((item) => renderToast(item))}
    </div>
  )
};

ToastContainer.propTypes = {
  toasts: PropTypes.object.isRequired
};

const mapStateToProps = ({ toastAlerts }) => ({
  toasts: toastAlerts.get('toasts')
});

export default connect(mapStateToProps)(ToastContainer);
